import config from 'src/config';
import type { FooterLink, SocialLink } from './types';
import {
  PATH_ABOUT_US,
  PATH_BREED,
  PATH_CAREERS,
  PATH_DIY,
  PATH_FAQ,
  PATH_LOGIN,
  PATH_REVIEWS,
  PATH_SIGNUP,
} from '@farmersdog/constants/paths';
import {
  LINK_AFFILIATES,
  LINK_DIGEST,
  LINK_FB,
  LINK_IG,
  LINK_PARTNERSHIP_INQUIRIES,
  LINK_TK,
} from '@farmersdog/constants/links';
import { EMAIL_PRESS } from '@farmersdog/constants/emails';

import FacebookNewSvg from 'src/assets/icons/facebook-new.svg';
import InstagramNewSvg from 'src/assets/icons/instagram-new.svg';
import Tiktok from 'src/assets/icons/tiktok.svg';

export const SITEMAP_LINKS: FooterLink[] = [
  { label: 'Reviews', href: PATH_REVIEWS },
  { label: 'About Us', href: PATH_ABOUT_US },
  { label: 'FAQs', href: PATH_FAQ },
  { label: 'Log In', href: PATH_LOGIN },
  { label: 'Sign Up', href: PATH_SIGNUP },
  { label: 'Digest', href: `${LINK_DIGEST}/` },
  { label: 'DIY', href: PATH_DIY },
  {
    label: 'Careers',
    href: PATH_CAREERS,
    target: '_blank',
    badge: 'We’re Hiring!',
  },
  {
    label: 'Affiliates',
    href: LINK_AFFILIATES,
    target: '_blank',
    rel: 'noopener noreferrer',
  },
  {
    label: 'For Vet Professionals',
    href: `${config('app.vetPortalUrl')}`,
    target: '_blank',
    rel: 'noopener noreferrer',
  },
  {
    label: 'Breeds',
    href: PATH_BREED,
  },
];

export const CONTACT_LINKS: FooterLink[] = [
  {
    label: 'Media Inquiries',
    href: `mailto:${EMAIL_PRESS}`,
  },
  {
    id: 'partnership-inquiries',
    label: 'Partnership Inquiries',
    href: LINK_PARTNERSHIP_INQUIRIES,
    target: '_blank',
    rel: 'noopener noreferrer',
  },
];

export const SOCIAL_LINKS: SocialLink[] = [
  {
    href: LINK_IG,
    icon: InstagramNewSvg,
    target: '_blank',
    rel: 'noopener noreferrer',
    'aria-label': 'Instagram',
    label: 'Instagram',
  },
  {
    href: LINK_FB,
    icon: FacebookNewSvg,
    target: '_blank',
    rel: 'noopener noreferrer',
    'aria-label': 'Facebook',
    label: 'Facebook',
  },
  {
    href: LINK_TK,
    icon: Tiktok,
    target: '_blank',
    rel: 'noopener noreferrer',
    'aria-label': 'TikTok',
    label: 'TikTok',
  },
];
